module.exports = __webpack_public_path__ + "img/CRT_Spear-001.5dc81aef.png";